import { useEffect } from 'react';
import { useViewFormsQuery } from '../services/api';
import { errorToast } from '../utils/toasts';

/**
 * Fetch forms (acceptable params are id)
 * The parameters are optional
 */
export const useFetchForms = ({ id } = {}) => {
  const { data, error, isError, isFetching, isLoading } = useViewFormsQuery({
    id,
  });

  useEffect(() => {
    if (isError) {
      errorToast('Unable to fetch feedback forms. Please try again later.');
      console.error(error);
    }
  }, [error, isError]);

  return {
    data,
    isError,
    isFetching,
    isLoading,
    forms: data && data.forms ? data.forms : [],
  };
};
